"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fx_1 = require("../../lib/fx");
const expoSensor_1 = require("../../lib/expoSensor");
const base64_1 = require("../../lib/base64");
const wmLogger_1 = require("../../lib/wmLogger");
const statRule_1 = require("./statRule");
wmLogger_1.WmLogger.getRuleManager().setRules(statRule_1.default);
if (process.env.BROWSER) {
    require('./UnionAd.less');
}
const MOCK_AD = {
    success: 'true',
    advertiser: 'union',
    id: 'N/ee02bbfa-2756-4691-bb67-40cd1eec93ef',
    title: '怪物彈珠',
    description: '有4沒事都要玩！站著玩､坐著玩､躺著都可以玩！不管什麼時候,不管在哪裡,滑一下,一指神功就可以擊退敵人的超簡單日本人氣手遊！最夯的聯名角色即將登場！！......',
    cta: 'Learn More',
    rating: 4.5,
    price: '',
    icon: {
        url: 'aHR0cDovL2Nkbi1hZG4ucmF5anVtcC5jb20vY2RuLWFkbi92Mi9vZmZlcnN5bmMvMTgvMDUvMjgv\nMTcvMDQvNWIwYmM2MjJjYmZlMS5qcGc=\n',
        base64: 'url',
        width: '64',
        height: '64',
    },
    covers: [
        {
            url: 'aHR0cDovL2Nkbi1hZG4ucmF5anVtcC5jb20vY2RuLWFkbi92Mi9vZmZlcnN5bmMvMTgvMDgvMDgv\nMTcvMjUvNWI2YWI2ZWU1YjMwMy5qcGc=\n',
            base64: 'url',
            width: '1200',
            height: '627',
        },
    ],
    choices_icon: {
        url: '',
        base64: 'url',
        width: '0',
        height: '0',
    },
    choices_url: '',
};
const MOCK_FB = {
    success: true,
    advertiser: 'facebook',
    id: 'N/902bf8ff-7b0b-4d4a-82cb-9bd8c232a8e1',
    style: 1,
    title: 'Facebook Test Ad',
    description: 'Your ad integration works. Woohoo!',
    cta: 'Learn More',
    rating: 0,
    price: '',
    icon: {
        url: 'aHR0cHM6Ly9zdGF0aWMueHguZmJjZG4ubmV0L3JzcmMucGhwL3YzL3kyL3IvSGd4bXl6S1VJOXIu\ncG5n\n',
        base64: 'url',
        width: 128,
        height: 128,
    },
    covers: [
        {
            url: 'aHR0cHM6Ly9zdGF0aWMueHguZmJjZG4ubmV0L3JzcmMucGhwL3YzL3liL3IvRTVXM0JCRmN6Mlku\ncG5n\n',
            base64: 'url',
            width: 2552,
            height: 1306,
        },
    ],
    choices_icon: {
        url: 'aHR0cHM6Ly9zdGF0aWMueHguZmJjZG4ubmV0L3JzcmMucGhwL3YzL3lPL3IvS29XQ0dlcFNCckIu\ncG5n\n',
        base64: 'url',
        width: 16,
        height: 16,
    },
    choices_url: 'aHR0cHM6Ly9tLmZhY2Vib29rLmNvbS9hZHMvYWRfY2hvaWNlcy8_YWRfdG9rZW49ZGVtb19hZF9j\nbGllbnRfdG9rZW4mYXBwX2lkPTE1Njc2NjM0ODY4MjMwOTI=\n',
};
class UnionAds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            title: '',
            adsPicUrl: '',
            adsId: '',
            adsCta: '',
            advertiser: '',
            adchoiceUrl: '',
            adchoiceIcon: {},
            adchoiceIconUrl: '',
            adsDescription: '',
        };
        this.ref = React.createRef();
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.slotId === this.props.slotId) {
            return false;
        }
    }
    componentDidMount() {
        this.getAds();
        expoSensor_1.default.addHook({
            el: this.ref.current,
            onExpo: () => {
                const { adsId, success, title, advertiser } = this.state;
                const { slotId } = this.props;
                if (!success) {
                    return;
                }
                console.log('曝光');
                setTimeout(() => {
                    wmLogger_1.WmLogger.log({
                        adsId: adsId || '',
                        adsTitle: title || '',
                        advertiser: advertiser || '',
                        placement_id: slotId,
                    }, 'show_ads');
                    fx_1.callJssdk('promotion.impressionAd', {
                        id: adsId,
                        placement_id: slotId,
                    });
                }, 500);
            },
        });
    }
    getAds() {
        const { pos, pubId, slotId, cpid, articleid, ch_id1 } = this.props;
        // TODO:
        // console.log('这里是测试广告MOCK数据，记得删除');
        // this.setAds(MOCK_AD);
        wmLogger_1.WmLogger.log({
            placement_id: slotId,
        }, 'apply_ads');
        console.log('get Ads', JSON.stringify({
            pub: pubId,
            adParams: [
                'cp',
                cpid,
                'ad_slot',
                '1',
                'ad_style',
                '1',
                'placement_id',
                slotId,
                'article_id',
                articleid,
                'channel',
                ch_id1,
            ],
        }));
        fx_1.callJssdk('promotion.getAd', {
            pub: pubId,
            adParams: [
                'cp',
                cpid,
                'ad_slot',
                '1',
                'ad_style',
                '1',
                'placement_id',
                slotId,
                'article_id',
                articleid,
                'channel',
                ch_id1,
            ],
            success: this.setAds.bind(this),
            fail: (e) => {
                console.log('get Ads fail', e);
                wmLogger_1.WmLogger.log({
                    code: e.errCode ? e.errCode : '',
                    msg: e.errMsg ? e.errMsg : '',
                    placement_id: slotId,
                }, 'fail_ads');
            },
        });
    }
    setAds(res) {
        console.log('广告', res);
        if (!res.success) {
            return;
        }
        const { slotId } = this.props;
        wmLogger_1.WmLogger.log({
            adsId: res.id || '',
            adsTitle: res.title || '',
            advertiser: res.advertiser || '',
            placement_id: slotId,
        }, 'pull_ads');
        this.setState({
            success: true,
            title: res.title,
            adsPicUrl: base64_1.default.decode(res.covers[0].url),
            adsId: res.id,
            adsCta: res.cta,
            advertiser: res.advertiser,
            adchoiceUrl: base64_1.default.decode(res.choices_url || ''),
            adchoiceIcon: res.choices_icon || {},
            adchoiceIconUrl: base64_1.default.decode((res.choices_icon || {}).url || ''),
            adsDescription: res.description,
        });
    }
    renderAdchoiceIcon() {
        const { advertiser, adchoiceIconUrl, adchoiceIcon, adchoiceUrl, } = this.state;
        if (advertiser === 'facebook' && adchoiceUrl && adchoiceIconUrl) {
            return (React.createElement("div", { className: "w-adchoise", "data-adchoise": true, onClick: (e) => {
                    e.stopPropagation();
                    location.href = adchoiceUrl;
                }, style: {
                    background: `rgba(255,255,255,.6) url(${adchoiceIconUrl}) no-repeat`,
                    backgroundSize: adchoiceIcon.width,
                    width: adchoiceIcon.width,
                    height: adchoiceIcon.height,
                } }));
        }
        return null;
    }
    // 默认大卡 还是大大卡
    renderBigBigCard(isBigBig) {
        const { title, adsPicUrl, adsDescription, adsCta } = this.state;
        return (React.createElement("div", { className: isBigBig ? 'ads-big-big' : 'ads-big' },
            React.createElement("div", { className: "w-icon-banner" },
                React.createElement("div", { className: "w-icon-banner-cover" },
                    React.createElement("div", { className: "img" },
                        React.createElement("img", { src: adsPicUrl || 'https://img.ucweb.com/s/uae/g/1s/flow/lubg.png', "uc-image-reader_state": "disabled" })),
                    this.renderAdchoiceIcon()),
                React.createElement("div", { className: "w-icon-banner-panel" },
                    React.createElement("div", { className: "w-icon-banner-title" },
                        React.createElement("div", { className: "w-desc" }, adsDescription)),
                    React.createElement("div", { className: "w-info" },
                        React.createElement("div", { className: "ad-flag" }, "AD"),
                        React.createElement("div", { className: "ad-title" }, title),
                        React.createElement("div", { className: "ad-btn" }, adsCta))))));
    }
    renderSmallCard() {
        const { title, adsPicUrl, adsDescription, adsCta } = this.state;
        return (React.createElement("div", { className: "ads-small" },
            React.createElement("div", { className: "box" },
                React.createElement("div", { className: "w-ads-img", "data-adimg": true },
                    React.createElement("img", { src: adsPicUrl || 'https://img.ucweb.com/s/uae/g/1s/flow/lubg.png', "uc-image-reader_state": "disabled" })),
                React.createElement("div", { className: "w-body" },
                    React.createElement("div", { className: "w-desc" }, adsDescription),
                    React.createElement("div", { className: "w-info" },
                        React.createElement("div", { className: "ad-flag" }, "AD"),
                        React.createElement("div", { className: "ad-title" }, title),
                        React.createElement("div", { className: "ad-btn" }, adsCta))),
                this.renderAdchoiceIcon())));
    }
    handleClickAd() {
        const { adsId, advertiser, title } = this.state;
        const { slotId } = this.props;
        wmLogger_1.WmLogger.log({
            adsId: adsId || '',
            adsTitle: title || '',
            advertiser: advertiser || '',
            placement_id: slotId,
        }, 'click_ads');
        fx_1.callJssdk('promotion.clickAd', {
            id: adsId,
            placement_id: slotId,
        });
    }
    render() {
        const { success } = this.state;
        if (!success) {
            return React.createElement("div", { ref: this.ref });
        }
        return (React.createElement("div", { ref: this.ref, onClick: this.handleClickAd.bind(this) }, success ? this.renderSmallCard() : null));
    }
}
exports.default = UnionAds;
//# sourceMappingURL=data:application/json;base64,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